import { Button, Card, Typography } from "antd"
import { useAccidents } from "./queries"
import { useEventId, usePresenceId } from "pages/events"
import { useExecutionMember } from "../queries"
import Main from "modules/layout/dashboard/main"
import { useEvent } from "pages/events/queries"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import Loader from "components/loader"
import styles from "./styles.module.scss"
import { usePopup } from "utils/use-popup"
import CreateAccidentDrawer from "./create"
import { ReactComponent as ShowIcon } from "assets/icons/show.svg"
import { ReactComponent as DeleteIcon } from "assets/icons/delete.svg"
import DeleteModal from "./delete"
import { formatTimeToCurrentTimezone } from "utils/format-datetime"

const { Title } = Typography

const Accidents: React.FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const createDrawer = usePopup()
  const deleteAccident = usePopup<string>()
  const eventId = useEventId()
  const presenceId = usePresenceId()
  const event = useEvent(eventId!)
  const member = useExecutionMember(eventId!, presenceId!)
  const accidents = useAccidents(eventId!, member.data?.member.id!, {
    enabled: member.isFetched,
  })
  const isLoading = event.isLoading || member.isLoading || accidents.isLoading
  return (
    <>
      <Main.PageHeader
        title={<Title level={3}>{member.data?.member.name}</Title>}
        rightContent={
          <Button
            size="large"
            type="primary"
            loading={event.isLoading}
            onClick={createDrawer.open}
          >
            {t("accidents.add_accident")}
          </Button>
        }
      />
      <div className={styles.listContainer}>
        {isLoading ? (
          <Loader />
        ) : (
          accidents.data?.map((item) => (
            <Card key={item.id} className={styles.accidentCard}>
              <Card.Grid
                style={{
                  width: "50%",
                  padding: 10,
                  display: "flex",
                  alignItems: "center",
                }}
                hoverable={false}
              >
                {formatTimeToCurrentTimezone(item.accident_at)}
              </Card.Grid>
              <Card.Grid
                style={{
                  width: "50%",
                  padding: 10,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
                hoverable={false}
              >
                <Button
                  onClick={() => navigate(item.id)}
                  className={styles.iconButton}
                  icon={<ShowIcon />}
                />
                <Button
                  onClick={() => deleteAccident.open(item.id)}
                  className={styles.iconButton}
                  icon={<DeleteIcon />}
                />
              </Card.Grid>
            </Card>
          ))
        )}
      </div>
      <CreateAccidentDrawer {...createDrawer} open={createDrawer.isOpen} />
      <DeleteModal {...deleteAccident} open={deleteAccident.isOpen} />
    </>
  )
}

export default Accidents
